module.exports = __webpack_public_path__ + "static/media/vnda2.6502a910.png";